// extracted by mini-css-extract-plugin
export default {"hamburgerButton":"MenuToggle_hamburgerButton__ELf0O"};